/*================================================================
‘Copyright © 2020, Cheers Interactive Pvt Ltd.  All rights reserved.
	 File Description : Footer bar for deliverable Add | Edit Page
 ---------------------------------------------------------------------------------
	Creation Details
	Date Created				: 21/Aug/2020
	Author						: Aditya Tijare
================================================================
*/
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import DataPublishingAction from "../../../../dataPublishing/deliverable/actionButton";
import { accessRightActionCheck, getProductVariant } from "../../../../../../utilities";
import { COMMON_ACCESS_ACTION, DELIVERABLE_TYPE } from "../../../../../../constants";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { PRODUCT_VARIANT, SUCCESS_TREND } from "constants";
import { updateTrends } from "middleware/services/deliverablesApi";
import { actionSuccess, actionError } from "middleware/actions/utilityAction";

const FooterBar = (props) => {
  const dispatch = useDispatch();
  const productVariant = getProductVariant();

  const { deliverableContentStatus, selectedIndex } = props;
  const [cancelRedirectLink, setCancelRedirectLink] = useState("/deliverable");
  const [interfaceActionAccess, setInterfaceActionAccess] = useState([]);

  useEffect(() => {
    if (props.pageId && props.activeStepper == "#content") {
      setCancelRedirectLink(`/deliverable/${props.deliverableId}/edit#content`);
    } else {
      setCancelRedirectLink(`/deliverable`);
    }
  }, [props.pageId]);

  /* Interface action access from common access */
  useEffect(() => {
    let interfaceName = Object.values(props?.hashArr)[props?.selectedIndex];
    let actionAccess = accessRightActionCheck(props?.moduleName, interfaceName);
    setInterfaceActionAccess(actionAccess);
  }, [props.selectedIndex]);

  let actionAccessSave = interfaceActionAccess.includes(COMMON_ACCESS_ACTION.SAVE);
  let actionAccessApprove = interfaceActionAccess.includes(COMMON_ACCESS_ACTION.APPROVE);
  let actionAccessReject = interfaceActionAccess.includes(COMMON_ACCESS_ACTION.REJECT);
  let actionAccessSubmit = interfaceActionAccess.includes(COMMON_ACCESS_ACTION.SUBMIT);
  let actionAccessPublish = interfaceActionAccess.includes(COMMON_ACCESS_ACTION.PUBLISH);

  const udpateTempTrends = async () => {
    await updateTrends(props.deliverableId)
      .then((res) => {
        if (res) {
          dispatch(actionSuccess(SUCCESS_TREND));
        } else {
          dispatch(actionError("Something went wrong"));
        }
      })
      .catch((err) => {
        dispatch(actionError(err?.data?.message || "Something went wrong"));
      });
  };

  return (
    <div className="form-submit-box">
      <div className="footer-layout">
        {props.selectedIndex > 0 || props.selectedIndex === undefined ? (
          <button
            type="button"
            className="cy-prev-btn btn btn-outline-dark cy-btn"
            onClick={() => {
              props.deliverableType === DELIVERABLE_TYPE.CLIENT_BUSINESS_OBJECTIVE
                ? (props.selectedIndex === undefined && props.setCurrentTab(2)) ||
                  (props.selectedIndex < 4 && props.setCurrentTab(props.selectedIndex - 1))
                : props.deliverableDocuments
                ? (props.selectedIndex === undefined && props.setCurrentTab(2)) ||
                  (props.selectedIndex <= 4 && props.setCurrentTab(props.selectedIndex - 4))
                : (props.selectedIndex === undefined && props.setCurrentTab(2)) ||
                  (props.selectedIndex < 5 && props.setCurrentTab(props.selectedIndex - 1));
            }}
          >
            Previous
          </button>
        ) : null}

        {props.deliverableType === DELIVERABLE_TYPE.CLIENT_BUSINESS_OBJECTIVE && props.deliverableDocuments ? null : props.deliverableId !== "" &&
          props.selectedIndex > -1 &&
          props.selectedIndex < 4 ? (
          <>
            {props.deliverableType === DELIVERABLE_TYPE.CLIENT_BUSINESS_OBJECTIVE && props.selectedIndex === 1 ? null : (
              <button
                type="button"
                className="cy-next-btn btn btn-outline-dark cy-btn"
                onClick={() => {
                  props.deliverableType === DELIVERABLE_TYPE.CLIENT_BUSINESS_OBJECTIVE
                    ? props.selectedIndex < 1 && props.setCurrentTab(props.selectedIndex + 1)
                    : props.deliverableDocuments
                    ? props.selectedIndex < 1 && props.setCurrentTab(props.selectedIndex + 4)
                    : props.selectedIndex < 4 && props.setCurrentTab(props.selectedIndex + 1);
                }}
              >
                Next
              </button>
            )}
          </>
        ) : null}
      </div>
      <div className="footer-layout">
        <Link to={cancelRedirectLink}>
          <button type="button" className="btn btn-outline-dark cy-btn">
            Cancel
          </button>
        </Link>
        <button type="button" className="btn btn-primary" style={{ display: "none" }} id="btn-save-as-template">
          Save As Template
        </button>
        {/* <span id="span-save-as-template"></span> */}
        {(props.showSave && [2].indexOf(selectedIndex) != -1 && props.contentTabAccess) ||
        (((actionAccessSave && ["In Progress", "Rejected", "Published", "Approved", "Submitted", ""].includes(deliverableContentStatus)) ||
          actionAccessApprove) &&
          [0, 2].indexOf(selectedIndex) != -1 &&
          props.showSave) ? (
          <button
            type="button"
            className="btn btn-primary cy-btn"
            id="dev-deliverable-save"
            onClick={() => {
              props.handleSave(true);
            }}
          >
            Save
          </button>
        ) : null}
        {actionAccessSave && [].indexOf(selectedIndex) != -1 && props.showSave ? (
          <button
            type="button"
            className="btn btn-primary cy-btn"
            id="dev-deliverable-save"
            onClick={() => {
              props.handleSave(true);
            }}
          >
            Save
          </button>
        ) : null}
        {((actionAccessSubmit && ["In Progress", "Rejected", ""].includes(deliverableContentStatus)) || actionAccessApprove) &&
        [2].indexOf(selectedIndex) != -1 &&
        props.contentTabAccess ? (
          <button
            type="button"
            className="btn btn-primary cy-btn"
            id="dev-deliverable-save"
            onClick={() => {
              props.handleSubmit();
            }}
          >
            Submit
          </button>
        ) : null}
        {props.contentTabAccess && actionAccessReject && [2].indexOf(selectedIndex) != -1 ? (
          <button
            type="button"
            className="btn btn-primary cy-btn"
            id="dev-deliverable-save"
            onClick={() => {
              props.handleReject();
            }}
          >
            Reject
          </button>
        ) : null}
        {props.contentTabAccess && actionAccessApprove && [2].indexOf(selectedIndex) != -1 ? (
          <button
            type="button"
            className="btn btn-primary cy-btn"
            id="dev-deliverable-save"
            onClick={() => {
              props.handleApprove();
            }}
          >
            Approve
          </button>
        ) : null}
        {actionAccessPublish || [0, 2, 4].indexOf(selectedIndex) != -1 ? (
          <DataPublishingAction deliverableId={props.deliverableId} {...props} />
        ) : null}
        {props.selectedIndex === 3 && productVariant === PRODUCT_VARIANT.INSIDER ? (
          <button
            type="button"
            className="btn btn-primary cy-btn"
            id="dev-deliverable-save"
            onClick={() => {
              udpateTempTrends();
              props.setSaveTrendTreeData(true);
            }}
          >
            Save
          </button>
        ) : null}
      </div>
    </div>
  );
};
FooterBar.propTypes = {
  deliverableContentStatus: PropTypes.string,
  selectedIndex: PropTypes.number,
  pageId: PropTypes.string,
  activeStepper: PropTypes.string,
  deliverableId: PropTypes.string,
  hashArr: PropTypes.object,
  moduleName: PropTypes.string,
  setCurrentTab: PropTypes.func,
  deliverableType: PropTypes.string,
  deliverableDocuments: PropTypes.array,
  showSave: PropTypes.bool,
  contentTabAccess: PropTypes.bool,
  handleSave: PropTypes.func,
  actionAccessApprove: PropTypes.bool,
  handleReject: PropTypes.func,
  handleApprove: PropTypes.func,
  handleSubmit: PropTypes.func,
  setSaveTrendTreeData: PropTypes.func,
};

export default FooterBar;
